import React, { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';
import { useAuth } from '../../../contexts/AuthContext';
import Icon from '../../../components/AppIcon';

const ReviewMetrics = () => {
  const { user } = useAuth();
  const [metrics, setMetrics] = useState({
    totalReviews: 0,
    averageRating: 0,
    pendingReviews: 0,
    featuredReviews: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.id) {
      loadMetrics();
    }
  }, [user]);

  const loadMetrics = async () => {
    try {
      setLoading(true);

      const { count: totalCount } = await supabase?.from('provider_reviews')?.select('*', { count: 'exact', head: true })?.eq('provider_id', user?.id);

      const { count: pendingCount } = await supabase?.from('provider_reviews')?.select('*', { count: 'exact', head: true })?.eq('provider_id', user?.id)?.eq('status', 'pending');

      const { count: featuredCount } = await supabase?.from('provider_reviews')?.select('*', { count: 'exact', head: true })?.eq('provider_id', user?.id)?.eq('is_featured', true);

      const { data: ratingsData } = await supabase?.from('provider_reviews')?.select('rating')?.eq('provider_id', user?.id);

      const averageRating =
        ratingsData?.length > 0
          ? (ratingsData?.reduce((sum, r) => sum + r?.rating, 0) / ratingsData?.length)?.toFixed(1)
          : 0;

      setMetrics({
        totalReviews: totalCount || 0,
        averageRating,
        pendingReviews: pendingCount || 0,
        featuredReviews: featuredCount || 0,
      });
    } catch (error) {
      console.error('Error loading metrics:', error);
    } finally {
      setLoading(false);
    }
  };

  const metricCards = [
    {
      label: 'Totaal Reviews',
      value: metrics?.totalReviews,
      icon: 'MessageSquare',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      label: 'Gemiddelde Score',
      value: `${metrics?.averageRating} ★`,
      icon: 'Star',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
    },
    {
      label: 'Te Beantwoorden',
      value: metrics?.pendingReviews,
      icon: 'Clock',
      color: 'text-error',
      bgColor: 'bg-error/10',
    },
    {
      label: 'Uitgelichte Reviews',
      value: metrics?.featuredReviews,
      icon: 'Award',
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="bg-card border border-border rounded-lg p-6 animate-pulse">
            <div className="h-12 bg-muted rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metricCards?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">{metric?.label}</p>
              <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
            </div>
            <div className={`${metric?.bgColor} p-3 rounded-lg`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReviewMetrics;